import { render, staticRenderFns } from "./IconRow.vue?vue&type=template&id=587417b1&"
import script from "./IconRow.vue?vue&type=script&lang=js&"
export * from "./IconRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports